import React from 'react';
import Button from '../../../../components/Button/Button';
import { PortalWithState } from 'react-portal';
import SetWaterSiteModal from './SetWaterSiteModal';
import SetHazardProtectionStatusModal from './SetHazardProtectionStatusModal';
import { IdArrayInput } from '../../../../hooks/useTablePages';
import RequirePerms from '@/components/RequirePerms';
import useSessionInfo from '@/hooks/useSessionInfo';
import BulkTagModal from '../../../../components/TagPicker/BulkTagModal';

type WaterServicesActionsProps = { ids: IdArrayInput };

const WaterServicesActions: React.FC<WaterServicesActionsProps> = ({
  ids,
}): JSX.Element => {
  const { features } = useSessionInfo();
  const hasWaterHazards = features.includes('WATER_HAZARDS');
  return (
    <>
      {hasWaterHazards && (
        <RequirePerms waterServices="UPDATE">
          <PortalWithState closeOnOutsideClick closeOnEsc>
            {({ openPortal, closePortal, portal }) => (
              <>
                <Button
                  variant="outline"
                  disabled={!ids.length}
                  icon="edit"
                  onClick={openPortal}
                >
                  Set Hazard Site
                </Button>
                {portal(
                  <SetWaterSiteModal
                    siteType="HAZARD"
                    serviceIds={ids}
                    onClose={closePortal}
                  />
                )}
              </>
            )}
          </PortalWithState>
        </RequirePerms>
      )}
      {hasWaterHazards && (
        <RequirePerms waterServices="UPDATE">
          <PortalWithState closeOnOutsideClick closeOnEsc>
            {({ openPortal, closePortal, portal }) => (
              <>
                <Button
                  variant="outline"
                  disabled={!ids.length}
                  icon="hazard"
                  onClick={openPortal}
                >
                  Set Hazard Status
                </Button>
                {portal(
                  <SetHazardProtectionStatusModal
                    serviceIds={ids}
                    onClose={closePortal}
                  />
                )}
              </>
            )}
          </PortalWithState>
        </RequirePerms>
      )}
      <RequirePerms waterServices="UPDATE">
        <PortalWithState closeOnOutsideClick closeOnEsc>
          {({ openPortal, closePortal, portal }) => (
            <>
              <Button
                variant="outline"
                disabled={!ids.length}
                icon="plus-circle"
                onClick={openPortal}
              >
                Add Tags
              </Button>
              {portal(
                <BulkTagModal
                  selectedIds={ids}
                  objectType="waterService"
                  onClose={closePortal}
                />
              )}
            </>
          )}
        </PortalWithState>
      </RequirePerms>
    </>
  );
};

export default WaterServicesActions;
